import {
  InfoChipColor,
  InfoChipShape,
  InfoChipSize,
  InfoChipType,
} from '../info-chip/info-chip.types';

/** Optional chip rendered in the button-card header (composes `app-info-chip`). */
export type MunilyButtonCardChipConfig = {
  label: string;
  color?: InfoChipColor;
  type?: InfoChipType;
  size?: InfoChipSize;
  shape?: InfoChipShape;
};

export const DEFAULT_BUTTON_CARD_CHIP_COLOR: InfoChipColor = 'gray';
export const DEFAULT_BUTTON_CARD_CHIP_TYPE: InfoChipType = 'filled';
export const DEFAULT_BUTTON_CARD_CHIP_SIZE: InfoChipSize = 'small';
export const DEFAULT_BUTTON_CARD_CHIP_SHAPE: InfoChipShape = 'rounded-small';
